
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationListHeading: {
    id: "ConfigurationListHeading.text",
    defaultMessage: "Un-assigned Configurations",
  }, 
  configurationListAdd: {
    id: "ConfigurationListAdd.text",
    defaultMessage: "Add New Configuration",
  }, 
  configurationListNone: {
    id: "ConfigurationListNone.text",
    defaultMessage: "No configurations available yet",
  }, 
});

export default MESSAGES;